import { fetchPostUtility } from '~utilities/fetch';
import { transformAdviser } from './transformers';
import IAdviser from './IAdviser';

export async function adviserAddRequest(adviser: IAdviser): Promise<Response> {
    return fetchPostUtility('/advisers', transformAdviser(adviser));
}